import { useEffect, useState } from "react";
import { usePageState } from "../Layout";
import { apiUrl, executeRequest, getToken } from "../functions/requests";
import Spacer from "../components/Spacer";
import IconLoadingWave from "../icons/IconLoadingWave";
import Button from "../components/Button";
import List from "../components/List";

export default function Dashboard() {
  const { pageState, setPageState } = usePageState();
  const [userData, setUserData] = useState(pageState.userData || null);
  const [loading, setLoading] = useState(true);
  const [liveApplications, setLiveApplications] = useState(null);
  const [totalCustomers, setTotalCustomers] = useState(null);
  const [totalUsers, setTotalUsers] = useState(null);
  const [ideas, setIdeas] = useState([]);

  // Get overview information
  const getOverviewInfo = async () => {
    try {
      await executeRequest(
        apiUrl + "overview",
        "GET",
        null,
        { Authorization: "Bearer " + getToken() },
        (data) => {
          console.log(data);
          setTotalUsers(data.total_users);
          setTotalCustomers(data.total_customers);
          setLiveApplications(data.live_applications_info);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (error) {
      console.log(error);
    }
  };

  // Get registered ideas
  const getIdeas = async () => {
    if (userData.user_type !== "user") return;
    if (userData.role.slug !== "administrator") return;
    try {
      await executeRequest(
        apiUrl + "ideas",
        "GET",
        null,
        { Authorization: "Bearer " + getToken() },
        (data) => {
          console.log("Got ideas");
          console.log(data);
          setIdeas(data);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (error) {
      console.log(error);
    }
  };

  const loadInfo = async () => {
    setLoading(true);
    await getOverviewInfo();
    await getIdeas();
    setLoading(false);
  };

  useEffect(() => {
    loadInfo();
  }, []);

  return (
    <div>
      <h1 className="page-title">Dashboard</h1>
      <Button
        text="Reload data"
        loading={loading}
        onClicked={() => loadInfo()}
      />
      <Spacer />
      <h2 className="flex flex-align-center flex-gap-s">
        Live applications:{" "}
        {loading ? (
          <IconLoadingWave />
        ) : (
          liveApplications && liveApplications.length
        )}
      </h2>

      {userData !== null && userData.user_type === "user" && (
        <>
          <Spacer />
          <h2 className="flex flex-align-center flex-gap-s">
            Total customers:{" "}
            {loading ? <IconLoadingWave /> : totalCustomers && totalCustomers}
          </h2>
          {!loading && !totalCustomers && (
            <div>Error loading total customers</div>
          )}
        </>
      )}

      <Spacer />
      <h2 className="flex flex-align-center flex-gap-s">
        Total users: {loading ? <IconLoadingWave /> : totalUsers && totalUsers}
      </h2>
      {!loading && totalUsers === null && <div>Error loading total users</div>}

      {userData.user_type === "user" && (
        <>
          <Spacer height="var(--spaceXL)" />
          <h2>Ideas</h2>
          <Spacer />
          <List
            itemType="idea"
            headers={["Content", "Created by", "Created at"]}
            showActionsHeader={false}
            items={ideas}
            isLoading={loading}
          />
        </>
      )}
    </div>
  );
}
